import React, { useCallback, useEffect, useState } from "react";

import down from "../assets/down.png";
import img from "../assets/img.png";
import { useDropzone } from "react-dropzone";
import cross from "../assets/cross.png";
import { toast } from "react-toastify";
import Selectcustom from "../Info/Selectcustom";
import Selectcustoms from "../Info/Selectcustoms";
import { useNavigate, useParams } from "react-router-dom";
import { useUpdatelistMutation } from "../../services/api";
import { useSelector } from "react-redux";
import Navbars from "../Navbars";
import Sidebar from "../profile/Sidebar";
import Directories from "../profile/Directories";
function ListingUpdate() {
  const [updatelist] = useUpdatelistMutation();
  const navigator = useNavigate();
  const routeParams = useParams();
  const listingData = useSelector((state) => state.getBusiness.data);

  const [previewData, setPreviewData] = useState({});
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [street, setStreet] = useState("");
  const [dateTimeUpdate, setDateTimeUpdate] = useState(false);
  const [imagesPreview, setImagesPreview] = useState([]);
  const [images, setImages] = useState([]);
  const [city1, setCity1] = useState("");
  const [city2, setCity2] = useState("");
  const [state, setState] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [discription, setDiscription] = useState("");
  const [zip, setZip] = useState("");
  console.log("images",images);
  const [timeData, setTimeData] = useState([
    {
      day: "mon",
      open_time: "None",
      close_time: "None",
      closed: false,
    },
    {
      day: "tue",
      open_time: "None",
      close_time: "None",
      closed: false,
    },
    {
      day: "wed",
      open_time: "None",
      close_time: "None",
      closed: false,
    },
    {
      day: "thu",
      open_time: "None",
      close_time: "None",
      closed: false,
    },
    {
      day: "fri",
      open_time: "None",
      close_time: "None",
      closed: false,
    },
    {
      day: "sat",
      open_time: "None",
      close_time: "None",
      closed: false,
    },
    {
      day: "sun",
      open_time: "None",
      close_time: "None",
      closed: false,
    },
  ]);
  const onSubmit = async () => {
    const formData = new FormData();
    formData.append("id", previewData.id);
    formData.append("email", email);
    formData.append("description", discription);
    formData.append("business_name",name);
    formData.append("phone_number",phone);
    formData.append("street_name",street);
    formData.append("city_zip",zip);
    formData.append("city1",city1);
    formData.append("city2",city2);
    formData.append("state",state);
    formData.append("business_description",discription);
    if(dateTimeUpdate==true)
    formData.append("business_days_and_hours",timeData);
    else
    formData.append("business_days_and_hours",previewData.business_days_and_hours);
    formData.append("keyword",[1]);
    formData.append("category",1);

    if (images.length > 0)
      {
        images.forEach((file, index) => {
          formData.append(`images`, file); // Append each file to the form data with the same key
        });
        formData.append(`imagesUpdate`, true);
    }
    else
    formData.append(`imagesUpdate`, false);

    // console.log("form", JSON.stringify(Array.from(formData)));
    updatelist(formData)
      .unwrap()
      .then((payload) => {
        console.log(payload);

        toast.success("Business updated Successfully");
        navigator('/listing');
      })
      .catch((error) => {
        console.log(error);
        toast.success(error.data.detail);
      });
  };
  const onDrop = useCallback((acceptedFiles) => {
    console.log("acceptedFiles: ", acceptedFiles[0]);
    setImagesPreview([]);
    setImages(acceptedFiles);
    acceptedFiles.forEach((acceptedFiles) => {
      const reader = new FileReader();

      reader.onload = () => {
        if (reader.readyState === 2) {
          setImagesPreview((oldArray) => [...oldArray, reader.result]);
          // setImages(...[e.target.files]);
        }
      };

      reader.readAsDataURL(acceptedFiles);
    });
    // imagesList = [...imagesList, acceptedFiles[0]];
    // console.log("Accepted File: ", imagesList);

    // // console.log("Image URL: ", URL.createObjectURL(acceptedFiles[0]));
    // setImagesPreview(URL.createObjectURL(acceptedFiles[0]));
    // setImages(acceptedFiles[0]);

    // dispatch(setFourthPage({images:acceptedFiles[0]}));
  }, []);
  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  const handleOpenChange = (event, index) => {
    const newTimeData = [...timeData];
    newTimeData[index].open_time = event.target.value + ":00";
    setTimeData(newTimeData);
  };

  const handleCloseChange = (event, index) => {
    const newTimeData = [...timeData];
    newTimeData[index].close_time = event.target.value + ":00";
    setTimeData(newTimeData);
  };

  const handleClosedChange = (event, index, text) => {
    if (text === "close") {
      const newTimeData = [...timeData];
      newTimeData[index].closed = true;
      setTimeData(newTimeData);
    } else {
      const newTimeData = [...timeData];
      newTimeData[index].closed = false;
      setTimeData(newTimeData);
    }
  };

  useEffect(() => {
    let data=listingData.filter((val)=>{
        if(val.id==routeParams.id)
        return val
    })
    setPreviewData(data[0])
   
    setName(data[0].business_name);
    // setAddress(data[0].business_name);
    setStreet(data[0].street_name);
    setCity1(data[0].city1);
    setCity2(data[0].city2);
    setState(data[0].state);
    setPhone(data[0].phone_number);
    setEmail(data[0].email);
    setWebsite(data[0].website);

    setDiscription(data[0].business_description);
    setZip(data[0].city_zip);
    if (data[0].Media.length > 0) {
      let imgs = [];
      data[0].Media.forEach((val) => {
        imgs.push(val.cdn_link);
      });
      setImagesPreview(imgs);
    }
    console.log("data",data)
  }, [listingData]);

  
  

  return (
    <>
      <div className="conatiner-fluid" style={{ backgroundColor: "#F5F5F5" }}>
        <Navbars />
        {/* <button className='ad_btn mt-2 show_btn' onClick={buttonPress}>Menu</button> */}
        <div className="d-flex gap-5 pe-3 main_div">
          <Sidebar />
          <div className="main_grid pt-3">
            <div className="inner_div  ps-3 pe-3 mb-5 pb-5">
              <div className="d-flex justify-content-between gap-3 pt-4 flex-wrap ">
                <p className="adx_no">
                  Cube ADX - #00019298812
                </p>
                <div className="d-flex gap-1">
                  <p className="balance">Your Balance:</p>
                  <p>$1000.00</p>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <p className="label">1- Business Name</p>
                  <input className="input1" placeholder="Cube Adx" value={name} onChange={(e)=>setName(e.target.value)}/>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="w-100">
                    <p className="label">2- Business Category</p>
                    <div style={{ position: "relative", maxWidth: "600px" }}>
                      <Selectcustom
                        className="input2 w-100"
                        placeholder={"Message Services"}
                      />
                      <div
                        style={{
                          position: "absolute",
                          top: "5px",
                          right: "10px",
                        }}
                      >
                        <img src={down} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <p className="label">3- Address</p>
              <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <p className="label1">Street Number / Name</p>
                  <input className="input1 w-100" placeholder="106 Douers" value={street} onChange={(e)=>setStreet(e.target.value)}/>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 ">
                  <p className="label1">State</p>
                  <div style={{ position: "relative", maxWidth: "600px" }}>
                  <input className="input1 w-100" placeholder="106 Douers" value={state} onChange={(e)=>setState(e.target.value)}/>
                  </div>
                </div>
                <div className="col-lg-2 col-md-6 col-sm-6">
                  <p className="label1">City</p>
                  <div style={{ position: "relative", maxWidth: "600px" }}>
                  <input className="input1 w-100" placeholder="106 Douers" value={city1} onChange={(e)=>setCity1(e.target.value)}/>
                  </div>
                </div>
                <div className="col-lg-2 col-md-6 col-sm-6">
                  <p className="label1">City Zip</p>
                  <div style={{ position: "relative", maxWidth: "600px" }}>
                  <input className="input1 w-100" placeholder="106 Douers" value={zip} onChange={(e)=>setZip(e.target.value)}/>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <p className="label1">4- Phone Number</p>
                  <input className="input1 w-100" placeholder="106 Douers" value={phone} onChange={(e)=>setPhone(e.target.value)}/>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 ">
                  <p className="label2">
                    6-Upload up to 5 images{" "}
                    <span>
                      {" "}
                      (size must be (950px X 720px) and (1900px X 1440px) Each)
                    </span>{" "}
                  </p>
                  <button {...getRootProps()} className="upload_btn">Upload Files<input {...getInputProps()} /></button>
                </div>
                <div className="col-lg-2 col-md-6 col-sm-6 mt-1">
                  <p className="label2">Upload a Video </p>
                  <button  className="upload_btn" style={{ marginTop: "33px" }}>
                    Upload Files
                  </button>
                </div>
                <div className="col-lg-2 col-md-6 col-sm-6 mt-1">
                  <p className="label2">
                    Upload Logo image <br></br>
                    <span>(400px X 400 px) </span>{" "}
                  </p>
                  <button className="upload_btn" style={{ marginTop: "10px" }}>
                    Upload Files
                  </button>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <p className="label1">5- Business Email</p>
                  <input
                    className="input1 w-100"
                    placeholder="info@cubeadx.com"
                    value={email}
                    onChange={(e)=>setEmail(e.target.value)}
                  />
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 mt-1 ">
                  <div className="d-flex gap-1 flex-wrap">
                  {imagesPreview.map((img) => (
                  <img
                    src={img}
                    key={img}
                    alt="Images Preview"
                    className="mt-3 mr-2"
                    width="55"
                    height="52"
                  />
                ))}
                    {/* <img src={img}/> */}
                  </div>
                </div>
                <div className="col-lg-2 col-md-6 col-sm-6 mt-1">
                  <img src={img} />
                </div>
                <div className="col-lg-2 col-md-6 col-sm-6 mt-1">
                  <img src={img} />
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <p className="label1">
                    7- Add up to 10 key words
                    <span className="span_txt">
                      {" "}
                      ( Max 30 letters/keyword){" "}
                    </span>
                  </p>
                  <div className="input1 ps-2 pe-2 pb-2">
                    <div className="d-flex gap-1 flex-wrap">
                      <div className="badge_main">
                        <p>Los Angeles</p>
                        <div className="badge_inner">
                          <img src={cross} />
                        </div>
                      </div>
                      <div className="badge_main">
                        <p>Business</p>
                        <div className="badge_inner">
                          <img src={cross} />
                        </div>
                      </div>
                      <div className="badge_main">
                        <p>Mesa</p>
                        <div className="badge_inner">
                          <img src={cross} />
                        </div>
                      </div>
                      <div className="badge_main">
                        <p>Mesa</p>
                        <div className="badge_inner">
                          <img src={cross} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 ">
                  <div className="d-flex gap-1 flex-wrap">
                    <p className="label1">
                      8- Add extra City{" "}
                      <span className="span_txt">
                        {" "}
                        (you can choose different Cities){" "}
                      </span>
                    </p>
                    <div className="d-flex gap-1">
                      {/* <Selectcustom placeholder={"City - 1"}/> */}
                      <div style={{ position: "relative", maxWidth: "600px" }}>
                        <input
                          className="input1 w-100"
                          placeholder="City - 1"
                        />
                        <div
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "10px",
                          }}
                        >
                          <img src={down} />
                        </div>
                      </div>
                      <div style={{ position: "relative", maxWidth: "600px" }}>
                        <input
                          className="input1 w-100"
                          placeholder="City - 2"
                        />
                        <div
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "10px",
                          }}
                        >
                          <img src={down} />
                        </div>
                      </div>
                    </div>
                    <div className="input1 ps-2 pe-2 pb-2 mt-2">
                      <div className="d-flex gap-1 flex-wrap">
                        <div className="badge_main">
                          <p>Los Angeles</p>
                          <div className="badge_inner">
                            <img src={cross} />
                          </div>
                        </div>
                        <div className="badge_main">
                          <p>Business</p>
                          <div className="badge_inner">
                            <img src={cross} />
                          </div>
                        </div>
                        <div className="badge_main">
                          <p>Mesa</p>
                          <div className="badge_inner">
                            <img src={cross} />
                          </div>
                        </div>
                        <div className="badge_main">
                          <p>Mesa</p>
                          <div className="badge_inner">
                            <img src={cross} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <p className="label1">Business Website</p>
                  <input className="input1" placeholder="www.cubeadx.com" />
                </div>
              </div>
              <div>
              <div className='row mt-2'>
      <div className='col-xl-4 col-lg-6 col-md-12'>
        <p className='label1'>9- Business working days and hours  <button onClick={()=>setDateTimeUpdate(true)} className="upload_btn" style={{ marginTop: "33px" }}>
                    Update
                  </button></p> 
        {dateTimeUpdate==false && previewData.business_days_and_hours &&
                previewData.business_days_and_hours.map((elem) => {
                  return (
                    <div className="row">
                      <p className="label1 labels">Open - Close</p>
                      <div className=" col-lg-6 col-md-6 col-sm-12 ">
                        <div className="time_div">
                          <p className="days">{elem?.day.toUpperCase()}</p>
                        </div>
                      </div>
                      <div className=" col-lg-6 col-md-6 col-sm-12 ">
                        <div className="time_div">
                          <p className="days">
                            {elem.opening_time} - {elem.closing_time}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
        {dateTimeUpdate && timeData.map((value, index) => {
                  return (
                    <div
                      className="d-flex align-items-center justify-content-between time-parent"
                      style={{ overflow: "hidden" }}
                      key={index}
                    >
                      <div className="day_div">
                        <p className="day">{value.day.toUpperCase()}</p>
                        <div>
                          <p
                            onClick={(e) =>
                              handleClosedChange(e, index, "open")
                            }
                            className={!value.closed ? "status" : "status1"}
                          >
                            Open
                          </p>
                          <p
                            onClick={(e) =>
                              handleClosedChange(e, index, "close")
                            }
                            className={value.closed ? "status" : "status1"}
                          >
                            Close
                          </p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center justify-content-between seconed_main">
                        <div className="day2_div">
                          <div>
                            {/* <p className="times">{value.time}</p> */}
                            <input
                              type="time"
                              value={value.open_time}
                              onChange={(event) =>
                                handleOpenChange(event, index)
                              }
                              className="mb-2 time-input"
                            />
                            <div className="hour_div">
                              <p>00:00</p>
                            </div>
                          </div>

                          <div>
                            <p className="mode">{value.mode1}</p>
                            <p className="mode1">{value.mode2}</p>
                          </div>
                        </div>
                        <p className="mt-4">-</p>
                        <div className="day2_div">
                          {/* <p className="times">{value.time2}</p> */}

                          <input
                            type="time"
                            value={value.close_time}
                            onChange={(event) =>
                              handleCloseChange(event, index)
                            }
                            className="mb-2 time-input"
                          />
                          <div>
                            <p className="mode">{value.mode1}</p>
                            <p className="mode1">{value.mode2}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
      </div>
      <div className='col-xl-4 col-lg-6 col-md-12'>
        <p className='label1'>10- Business Description</p>
        <div style={{ position: "relative" }}>
          <textarea className='textarea' placeholder='Description...' value={discription} onChange={(e)=>setDiscription(e.target.value)}>
          </textarea>
          <p className='numbering'>10<span className='text'>/750</span></p>
        </div>
      </div>
      <div className='col-xl-4 col-lg-6 col-md-12 mt-3'>
        <Directories/>
      </div>
    </div>
    <div className='d-flex justify-content-center mt-5'>
      <button className='update_btn' onClick={()=>onSubmit()}>Update</button>
    </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ListingUpdate;
